import React, { createContext, useState, useEffect, useCallback } from 'react';
import {
  fetchNotifications as apiFetchNotifications,
  dismissNotification as apiDismissNotification,
} from '../api/notificationsApi';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch notifications on mount
  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiFetchNotifications();
        if (!cancelled) {
          setNotifications(data);
        }
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
        if (!cancelled) {
          setError('Failed to load notifications.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  // Only undismissed notifications
  const activeNotifications = notifications.filter((n) => !n.dismissed);

  // Dismiss a single notification
  const dismiss = useCallback(async (id) => {
    try {
      await apiDismissNotification(id);
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, dismissed: true } : n))
      );
    } catch (err) {
      console.error('Failed to dismiss notification:', err);
    }
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        notifications: activeNotifications,
        allNotifications: notifications,
        loading,
        error,
        dismissNotification: dismiss,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
